module.exports = __webpack_public_path__ + "img/ring_r_e_null_1@3x.aac5d6b1.png";